import styled from 'styled-components';

import { FlexContainer } from 'styles/layouts';

export const LoadingWrapper = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  justify-content: center;
`;
